module.exports = __webpack_public_path__ + "static/media/logo_ds_pivot_slash.031a0c55.svg";